export const isExisty = <T>(item: T | null | undefined): item is T =>
  item !== null && item !== undefined;

export const compact = <T>(items: (T | null | undefined)[] | (null | undefined)): T[] =>
  (items || []).filter<T>(isExisty) || [];
